/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "analytics/analytics";
import url from "utils/url";

const ACTIONS = {
    newest: "SORT_BY_NEWEST",
    price_desc: "SORT_BY_HIGH_LOW",
    price_asc: "SORT_BY_LOW_HIGH",
    recommended: "SORT_BY_RECOMMENDED"
};

const SORT_DROPDOWN_SELECTOR = ".sort-feed-dropdown";

export default baustein.register("sort-dropdown", {
    setupEvents(add) {
        add("change", SORT_DROPDOWN_SELECTOR, this._onChange);
    },

    /**
     * Handler for the change event on the sort dropdown. Emits
     * an event that'll be caught from the product feed, which will
     * be used to filter/sort the feed itself.
     */
    _onChange() {
        const value = this.el.querySelector("[data-dropdown]").value;

        this._trackSortingOption(value);
        this._updateDropdownLabel(value);

        const sortOption = url.parse(value).searchParams.get("view");
        this.emit("feedSortingChanged", { sortOption });
    },

    /**
     * Tracks the sorting change.
     *
     * @param {String}
     */
    _trackSortingOption(value) {
        const sortOption = url.parse(value).searchParams.get("view");
        const action = ACTIONS[sortOption];

        analytics.event("SORT_BY", action);
    },

    /**
     * Updates the dropdown label text to match the selected value.
     *
     * @param {String}
     */
    _updateDropdownLabel(value) {
        const dropdown = this.el.querySelector("[data-dropdown]");
        const selectedLabelText = dropdown
            .querySelector(`option[value="${value}"]`)
            .getAttribute("data-selected-label");
        const selectedTabletMobileLabelText = dropdown
            .querySelector(`option[value="${value}"]`)
            .getAttribute("data-selected-label-tablet-mobile");

        this.el.querySelector(
            ".selected-sort-by-option-label .hidden-tablet"
        ).textContent = selectedLabelText;
        this.el.querySelector(
            ".selected-sort-by-option-label .hidden-desktop"
        ).textContent = selectedTabletMobileLabelText;
    }
});

